import { render, staticRenderFns } from "./upcomingworkshop.vue?vue&type=template&id=5b159e6a&scoped=true&"
import script from "./upcomingworkshop.vue?vue&type=script&lang=js&"
export * from "./upcomingworkshop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b159e6a",
  null
  
)

export default component.exports